/**************************************************
 * Nombre:       Tarjeta_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {LINKWASS, NEGRITA} from "../../Constantes";
import linea from '../../Recursos/Iconos/ic_raya.svg'
import {East} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../Utilidades/irUrl";

const Tarjeta_Anuncios = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                color: '#fff',
                height: 450
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: !masSM ? 18 : 24, fontWeight: 400, lineHeight: 1.1}}>CENTRO DE
                        CONCILIACIÓN
                        <img src={linea} width={40} height={'auto'} alt={'linea'}
                             style={{marginTop: -7, marginBottom: 7, paddingLeft: 5}}/>
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: !masSM ? 40 : 54, fontWeight: 400, lineHeight: 1.1}}>
                        SOLUCIÓN DE CONFLICTOS PARA LA PAZ
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Typography sx={{fontSize: sCell ? 16 : 18, fontWeight: 400, lineHeight: sCell ? 1.3 : 1.1}}>
                        Vigilado por el Ministerio de Justicia y del Derecho.
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 6}}>
                    <Button
                        onClick={() => irUrl(LINKWASS)}
                        endIcon={<East/>}>Contactanos</Button>
                </Grid>

            </Grid>
        </Grid>
    )

}
export default Tarjeta_Anuncios